import React, {useEffect, useMemo, useState} from 'react';
import {message, Modal, Spin, Transfer, Typography} from 'antd';
import {getApis} from '../api/apiApi';
import {updateApiGroupMembers} from '../api/groupApi';

const { Text } = Typography;

/**
 * API 그룹 멤버 편집 모달
 * props:
 *  - open
 *  - group (API 타입 그룹 또는 null)
 *  - onCancel
 *  - onSuccess
 */
const GroupApiMembersModal = ({ open, group, onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [allApis, setAllApis] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await getApis();
        const list = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setAllApis(list.filter(a => a.apiId)); // apiId 존재하는 등록된 API만 대상
      } catch (e) {
        message.error('API 목록 조회 실패: ' + (e?.message || ''));
      } finally { setLoading(false); }
    };
    load();
  }, [open]);

  useEffect(() => {
    if (group && open) {
      setTargetKeys((group.trgtIdList || []).map(id => id));
    } else if (!open) {
      setTargetKeys([]);
    }
  }, [group, open]);

  const dataSource = useMemo(() => {
    return (allApis || []).map(a => ({
      key: a.apiId,
      title: a.apiNm || a.apiUrl || '(이름없음)',
      description: `${a.methodType || ''} ${a.apiUrl || ''}`.trim()
    }));
  }, [allApis]);

  const handleOk = async () => {
    if (!group) return;
    try {
      await updateApiGroupMembers(group.groupId, targetKeys);
      onSuccess?.();
    } catch (e) {
      message.error('저장 실패: ' + (e?.message || ''));
    }
  };

  return (
    <Modal
      open={open}
      title={group ? `API 멤버 편집 - ${group.groupNm}` : 'API 멤버 편집'}
      onCancel={onCancel}
      onOk={handleOk}
      okButtonProps={{ disabled: !group }}
      okText="저장"
      cancelText="취소"
      width={760}
      destroyOnClose
    >
      {!group && <Text type="secondary">API 타입 그룹을 먼저 선택하세요.</Text>}
      {group && (
        loading ? <div style={{textAlign:'center',padding:40}}><Spin /></div> : (
          <Transfer
            dataSource={dataSource}
            titles={['전체 API', '그룹 API']}
            targetKeys={targetKeys}
            onChange={setTargetKeys}
            listStyle={{ width: 320, height: 360 }}
            showSearch
            filterOption={(inputValue, item) => (item.title || '').toLowerCase().includes(inputValue.toLowerCase()) || (item.description || '').toLowerCase().includes(inputValue.toLowerCase())}
            locale={{ itemUnit:'개', itemsUnit:'개', searchPlaceholder:'검색', notFoundContent:'없음' }}
            render={item => `${item.title}${item.description ? ' ('+item.description+')':''}`}
          />
        )
      )}
    </Modal>
  );
};

export default GroupApiMembersModal;

